import { Users, TrendingUp, Compass } from "lucide-react"

interface StudentStatsProps {
  totalStudents: number
  avgPerformance: string
  topCareer: string
}

export function StudentStats({ totalStudents, avgPerformance, topCareer }: StudentStatsProps) {
  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-10">
      <div className="bg-card p-6 rounded-xl shadow-sm border border-border flex items-center gap-4">
        <div className="p-3 bg-blue-100 rounded-lg text-secondary">
          <Users className="w-6 h-6" />
        </div>
        <div>
          <p className="text-sm text-muted-foreground font-medium">Total Students</p>
          <h3 className="text-2xl font-bold text-foreground">{totalStudents}</h3>
        </div>
      </div>

      <div className="bg-card p-6 rounded-xl shadow-sm border border-border flex items-center gap-4">
        <div className="p-3 bg-teal-100 rounded-lg text-primary">
          <TrendingUp className="w-6 h-6" />
        </div>
        <div>
          <p className="text-sm text-muted-foreground font-medium">Avg. Performance</p>
          <h3 className="text-2xl font-bold text-foreground">{avgPerformance}%</h3>
        </div>
      </div>

      <div className="bg-card p-6 rounded-xl shadow-sm border border-border flex items-center gap-4">
        <div className="p-3 bg-purple-100 rounded-lg text-purple-600">
          <Compass className="w-6 h-6" />
        </div>
        <div>
          <p className="text-sm text-muted-foreground font-medium">Top Career Interest</p>
          <h3 className="text-2xl font-bold text-foreground">{topCareer}</h3>
        </div>
      </div>
    </div>
  )
}
